(function () {
  'use strict';

  function safeRun(label, fn) {
    try {
      fn();
    } catch (err) {
      if (window.console && console.error) console.error('[gbi]', label, err);
    }
  }

  function init() {
    safeRun('whatsapp widget', function () {
      var root = document.querySelector('[data-gbi-wa]');
      if (!root) return;
      var fab = root.querySelector('[data-gbi-wa-fab]');
      var panel = root.querySelector('[data-gbi-wa-panel]');
      var closeBtn = root.querySelector('[data-gbi-wa-close]');
      if (!fab || !panel) return;

      function open() {
        panel.hidden = false;
        fab.setAttribute('aria-expanded', 'true');
      }
      function close() {
        panel.hidden = true;
        fab.setAttribute('aria-expanded', 'false');
      }

      fab.addEventListener('click', function () {
        if (panel.hidden) open(); else close();
      });
      if (closeBtn) closeBtn.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) close();
      });

      document.addEventListener('click', function (e) {
        if (!panel.hidden && !root.contains(e.target)) close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
